export const DeviceInstallmentType = {
  BNPL: 'bnpl',
  INSTALLMENT: 'installment',
};

export const DeviceInstallmentCount = {
  BNPL: 4,
  INSTALLMENT: 12,
};
